/** API route map: URLS.Controller.ClientAttachment */
export const ClientAttachment = {
      Name: 'ClientAttachment/',
      GetAll: 'client-attachments',
      Add: 'add',
      DeleteAttachment: 'delete',
      ShareClientAttachment: 'share',
};
